{
  "notifications.title": "Notifications",
  "notifications.centerTitle": "Notification center",
  "notifications.pageDescription": "Review ticket assignments, mentions, and important updates in one place.",
  "notifications.openCenter": "Open notification center",
  "notifications.listLabel": "Notification list",
  "notifications.unreadCount": "Notifications, {count} unread",
  "notifications.new": "New notifications",
  "notifications.dismissPreview": "Dismiss notification preview",
  "notifications.all": "All",
  "notifications.unread": "Unread",
  "notifications.unreadShort": "{count} unread",
  "notifications.today": "Today",
  "notifications.earlier": "Earlier",
  "notifications.menu.label": "Notification views",
  "notifications.menu.filter": "Filter",
  "notifications.menu.assignedToMe": "Assigned to me",
  "notifications.menu.mentionedMe": "Mentions",
  "notifications.menu.participating": "Participation",
  "notifications.menu.system": "System alerts",
  "notifications.menu.settings": "Preferences",
  "notifications.menu.comingSoon": "Coming soon",
  "notifications.preferences.description": "Manage how notifications reach you.",
  "notifications.preferences.deliveryTitle": "Delivery",
  "notifications.preferences.deliveryDescription": "In-app updates are always available. Browser notifications are managed per device.",
  "notifications.preferences.inAppTitle": "In-app notifications",
  "notifications.preferences.inAppDescription": "Assignments, mentions, and important updates appear in your notification center.",
  "notifications.preferences.alwaysOn": "Always on",
  "notifications.loading": "Loading notifications…",
  "notifications.loadFailed": "Could not load notifications",
  "notifications.retry": "Retry",
  "notifications.emptyAll": "No notifications yet",
  "notifications.emptyUnread": "You're all caught up",
  "notifications.emptyAllDetail": "Ticket assignments, mentions, and other updates will appear here.",
  "notifications.emptyUnreadDetail": "New unread notifications will appear here.",
  "notifications.markAllRead": "Mark all as read",
  "notifications.markingAllRead": "Marking all as read",
  "notifications.markAllReadSuccess": "All current notifications are marked as read.",
  "notifications.loadMore": "View more",
  "notifications.loadingMore": "Loading more notifications",
  "notifications.relatedUnavailable": "Related content is no longer accessible.",
  "notifications.viewDetails": "View details",
  "notifications.category.ticket": "Ticket",
  "notifications.category.system": "System",
  "notifications.category.default": "Notification",
  "notifications.ticketAssigned": "Ticket {number} was assigned to you",
  "notifications.ticketAssignedGeneric": "A ticket was assigned to you",
  "notifications.ticketMentioned": "You were mentioned in ticket {number}",
  "notifications.ticketMentionedGeneric": "You were mentioned in a ticket",
  "notifications.ticketParticipantAdded": "You were added as a participant to ticket {number}",
  "notifications.ticketParticipantAddedGeneric": "You were added as a participant to a ticket",
  "notifications.ticketReopened": "Ticket {number} was reopened",
  "notifications.ticketReopenedGeneric": "A ticket was reopened",
  "notifications.push.title": "Browser notifications",
  "notifications.push.loading": "Checking this device…",
  "notifications.push.statusOn": "On",
  "notifications.push.statusOff": "Off",
  "notifications.push.enabledDescription": "Ticket alerts can appear when Tickbird is in the background.",
  "notifications.push.disabledDescription": "Get ticket alerts even when Tickbird is in the background.",
  "notifications.push.enable": "Enable",
  "notifications.push.onboardingTitle": "Get important notifications",
  "notifications.push.onboardingDescription": "Enable desktop notifications so assignments, mentions, and important status changes can reach you while you're away.",
  "notifications.push.onboardingEnable": "Enable notifications",
  "notifications.push.later": "Maybe later",
  "notifications.push.enabling": "Enabling…",
  "notifications.push.enablingDescription": "Requesting browser permission and registering this device.",
  "notifications.push.disable": "Turn off",
  "notifications.push.disabling": "Turning off…",
  "notifications.push.errorTitle": "Browser notifications could not be updated",
  "notifications.push.errorDescription": "Check your connection and try again.",
  "notifications.push.retry": "Retry browser notifications",
  "notifications.push.deniedTitle": "Browser notifications are blocked",
  "notifications.push.deniedDescription": "Allow notifications for this site in your browser settings, then try again.",
  "notifications.push.serverDisabledTitle": "Browser notifications are unavailable",
  "notifications.push.serverDisabledDescription": "Web Push is not configured on this Tickbird server.",
  "notifications.push.unsupportedTitle": "This device does not support browser notifications",
  "notifications.push.unsupportedDescription": "Use a browser and secure connection that support Web Push.",
  "notifications.push.enabledSuccess": "Browser notifications are enabled on this device.",
  "notifications.push.disabledSuccess": "Browser notifications are off on this device.",
  "notifications.push.disabledLocalOnly": "Notifications were turned off locally, but the server could not be reached.",
  "notifications.push.updateFailed": "Could not update browser notifications."
}
